import { handleActions } from "redux-actions";
import { fromJS } from "immutable";
import types from "../types";

const INITIAL_STATE = fromJS({
  isLoading: false,
  message: "",
});

const reducer = handleActions(
  {
    [types.CREATE]: (state) => state.set("isLoading", true),
    [types.CREATE_FAIL]: (state) => state.set("isLoading", false),
    [types.CREATE_SUCCESS]: (state, { payload: response }) =>
      state.set("isLoading", false).set("data", response.data.message),
    [types.CREATE_PASSWORD]: (state) => state.set("isLoading", true),
    [types.CREATE_PASSWORD_FAIL]: (state) => state.set("isLoading", false),
    [types.CREATE_PASSWORD_SUCCESS]: (state, { payload: response }) =>
      state.set("isLoading", false).set("data", response.data.message),
  },
  INITIAL_STATE
);

export default reducer;
